// extracted by mini-css-extract-plugin
module.exports = {"amenities__item":"amenities__item-Eama7"};